// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3wD7R","label":"Radio_label__3XbGS","checkMark":"Radio_checkMark__1baJH","disabled":"Radio_disabled__chOGW"};